import * as React from 'react';
// import { Link } from 'react-router-dom';
import Nav from './Nav.js';

const Header = (props) => (
    <header>
      <Nav />
    </header>
);

export default Header;